$(function () {
	$('body').on('click', '.js-message-comment-reply', function (event) {
		let respondingTo = $(this).data('responding-to');
		let $respondingTo = $('#respondingTo');
		if ($respondingTo.length) {
			$respondingTo.val(respondingTo);
		}
		event.preventDefault();
	});
});